module.exports = {"supportPhoneNumber":"514-343-3194","supportEmail":"ITSupport@Kruger.com","csrPhoneNumber":"1-800-265-7843","csrEmail":"KTrakCSRSupport@kruger.com"}


//////////////////
// WEBPACK FOOTER
// ./src/data/ContactInfo.json
// module id = 574
// module chunks = 0